<template>
  <div>
  </div>
</template>

<script>
import PaginationService from '@/services/paginationservice'
import * as code from '@/common/code'
import Util from '@/common/utility'
export default {
  data () {
    return {
      data: [],
      allData: [],
      originalData: [],
      loader: null,
      isDestroy: false,
      totalRecord: 0,
      localPage: this.currentPage,
      isLoading: false,
      keepSort: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    currentPage: {
      type: Number,
      default: 0
    },
    maxRows: {
      type: Number,
      default: 50
    },
    keyword: {
      type: [String, Object],
      default: ''
    },
    extraUrl: {
      type: Array
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: 'get'
    }
  },
  created () {
    this.fetchDataByAPI()
  },
  methods: {
    fetchDataByAPI () {
      if (this.isDestroy) return
      this.loader = this.$loading.show()
      let url = this.url
      let payload = null
      payload = {
        ...this.keyword
      }
      const apiMethod = this.method === 'get' ? PaginationService.getData : PaginationService.postDataByExtraUrl
      apiMethod(url, payload)
        .then((response) => {
          this.allData = [...response.data]
          this.originalData = JSON.parse(JSON.stringify(response.data))
          this.fetchDataClientMode()
        })
        .catch((err) => {
          if (err === code.amazonInfoNotFound) {
            this.$events.fire('noAmazon', false)
          } else {
            this.$emit('zIndex', 1040)
            this.$store.commit('toggleModal', {
              show: true,
              message: err
            })
          }
        })
        .finally(() => {
          this.loader && this.loader.hide()
          this.$events.fire('done', this.url)
        })
    },
    fetchDataClientMode (isShowLoading = false, keepSort = false) {
      this.keepSort = keepSort
      if (isShowLoading && !this.isLoading) {
        this.isLoading = true
        this.loader = this.$loading.show()
      }
      let allData = [...this.allData]
      if (this.keyword && this.keyword.length > 0) {
        allData = allData.filter((item) => {
          return (
            (item.asin && item.asin.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.ean && item.ean.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.productName && item.productName.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.itemName && item.itemName.toLowerCase().includes(this.keyword.toLowerCase()))
          )
        })
      }

      const totalPage = Math.ceil(allData.length / this.maxRows)
      if (totalPage > 0 && this.currentPage > totalPage) {
        this.localPage = 1
        this.$emit('updateCurrentPage', this.localPage)
      }
      if (totalPage !== this.totalPage) {
        this.$emit('updateTotalPage', totalPage)
      }
      let startPage = this.localPage - 1
      allData = allData.slice(startPage * this.maxRows, this.localPage * this.maxRows)
      this.data = [...allData]
      allData.length = 0

      if (this.extraUrlMode) {
        setTimeout(() => {
          const asinList = this.data.map(item => item.asin)
          this.fetchDataByExtraUrl(asinList)
        }, 1000)
      }

      if (isShowLoading) {
        setTimeout(() => {
          this.isLoading = false
          this.loader && this.loader.hide()
        }, 500)
      }
    },
    handleData (item, type) {
      if (type === 'delete') {
        this.allData = this.allData.filter(data => data.asin !== item.asin)
        this.originalData = this.originalData.filter(data => data.asin !== item.asin)
      } else if (type === 'add') {
        const productItem = this.productData.find((prd) => prd.asin === item.asin)
        let newItem = productItem ? {
          ...productItem,
          ean: item.ean
        } : {...item}
        this.allData.push({
          ...newItem,
          offerPrice: this.calculateOfferPrice(newItem, newItem)
        })
      } else if (type === 'update') {
        this.allData = this.allData.map((data) => {
          if (data.asin === item.asin && item.judgment) {
            data.judgmentStatus = item.judgment.judgmentStatusName
            data.judgmentStatusCode = item.judgment.judgmentCode
          }
          return data
        })
      } else if (type === 'deleteAll') {
        this.allData = this.allData.filter(data => !item.includes(data.asin))
        this.originalData = this.originalData.filter(data => !item.includes(data.asin))
      }
      this.fetchDataClientMode(false, true)
    },
    fetchDataByExtraUrl (asin) {
      if (this.extraUrl.length > 0) {
        this.extraUrl.forEach(async (url) => {
          const {chunkData, delayTime} = this.checkInvalidData(url, asin)
          if (chunkData.length > 0 && !this.isDestroy) {
            for (const item of chunkData) {
              const payload = {
                record: item
              }
              PaginationService.postDataByExtraUrl(url, payload)
                .then((response) => {
                  this.allData = this.allData.map((item) => {
                    const newItem = response.data.find(resItem => resItem.asin === item.asin)
                    if (newItem) {
                      if (this.url === 'PromotionProduct/available') {
                        return {
                          ...item,
                          ...newItem,
                          offerPrice: this.calculateOfferPrice(item, newItem)
                        }
                      }
                      return {
                        ...item,
                        ...newItem
                      }
                    }
                    return item
                  })
                  this.data = this.data.map((item) => {
                    const newItem = response.data.find(resItem => resItem.asin === item.asin)
                    if (newItem) {
                      if (this.url === 'PromotionProduct/available') {
                        return {
                          ...item,
                          ...newItem,
                          offerPrice: this.calculateOfferPrice(item, newItem)
                        }
                      }
                      return {
                        ...item,
                        ...newItem
                      }
                    }
                    return item
                  })
                })
                .catch((err) => {
                  this.$emit('zIndex', 1040)
                  this.$store.commit('toggleModal', {
                    show: true,
                    message: err
                  })
                })
              await Util.delay(delayTime)
            }
          }
        })
      }
    },
    checkInvalidData (extraUrl, asin) {
      let keys = []
      let maxDataPerRequest = 50
      let delayTime = 500
      switch (extraUrl) {
        case 'Product/get-price':
          keys = ['amazonPrice']
          maxDataPerRequest = 20
          delayTime = 100
          break
        case 'Product/get-image-name':
          keys = ['image']
          maxDataPerRequest = 20
          delayTime = 1000
          break
        case 'Product/get-stock-info':
          keys = ['numberOfStock']
          maxDataPerRequest = 50
          delayTime = 500
          break
        default:
          break
      }
      const matchData = this.allData.filter(item => {
        let match = false
        keys.forEach(key => {
          if (!Object.prototype.hasOwnProperty.call(item, key)) {
            match = true
          }
        })
        return asin.includes(item.asin) && match
      }).map(item => item.asin)
      const chunkData = Util.chunkArray(matchData, maxDataPerRequest)
      return {
        chunkData,
        delayTime
      }
    },
    reload () {
      this.fetchDataByAPI()
    },
    calculateOfferPrice (currentItem, newItem) {
      if (currentItem.offerPrice === 0) {
        return newItem.amazonPrice > 0 ? Math.round(newItem.amazonPrice * 0.9) : null
      }
      return currentItem.offerPrice
    }
  },

  watch: {
    data () {
      this.$emit('onChangePage', this.data, this.keepSort)
      if (this.keepSort) {
        this.keepSort = false
      }
    },
    originalData (newVal) {
      this.$emit('originalData', newVal)
    },
    keyword () {
      this.fetchDataClientMode(true, true)
    },
    maxRows () {
      this.fetchDataClientMode(true, true)
    },
    currentPage () {
      this.localPage = this.currentPage
      this.fetchDataClientMode(true, true)
    }
  },
  beforeDestroy () {
    this.isDestroy = true
    this.loader && this.loader.hide()
    this.$store.commit('toggleModal')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FetchDataClient.vue